/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 16:46:47
 * @LastEditTime: 2023-05-10 11:47:48
 * @LastEditors: Please set LastEditors
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/SubscriptionBuy/List/index.tsx
 */
import { NoDataPage } from '@/src/components';
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
// import { getCurrencies } from 'src/constrains/ConfigProvider/slice';
// import { useSelector } from 'react-redux';
import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import { useI18n } from '@/src/hooks/useRouterChange';
import {
  getSubscriptionList,
  getSubscriptionListInit,
} from '@/src/request/order';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { i18nGet, handleOnGetStoreTimezoneUTC } from '@/src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { get } from 'lodash';
import moment from 'moment';
import React, { memo, useState } from 'react';
import { useHistory } from 'react-router';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import {
  ETab,
  breadcrumbData,
  columns,
  filterList,
  tabDict,
  tabsConfig,
} from './config';
import css from './css.module.less';

const customerConvertQuery = (filter) => {
  const {
    priceAlert = [],
    salesChannelUuids = [],
    orderStatuses = [],
  } = filter;
  // console.log('filter',filter)
  const re: any = {};
  if (priceAlert && priceAlert.length > 0) {
    const alert = get(priceAlert, '0.value');
    if (alert == '1') {
      re.priceAlert = true;
    }
    if (alert == '0') {
      re.priceAlert = false;
    }
  }
  if (salesChannelUuids && salesChannelUuids.length > 0) {
    re.salesChannelUuids = salesChannelUuids.map((i) => {
      const { value } = i;
      return value;
    });
  }
  if (orderStatuses && orderStatuses.length > 0) {
    re.orderStatuses = orderStatuses.map((i) => {
      const { value } = i;
      return value;
    });
  }

  return re;
};
// TODO: 进入到subscriptionBuy 列表页面报错,权限未能添加
const permissions = () => {
  const view_subscription_buy_listing_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderSubscription,
        operation: EnumOperation.view_subscription_buy_listing_page,
      }),
    ],
  });
  const view_subscription_buy_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderSubscription,
        operation: EnumOperation.view_subscription_buy_details_page,
      }),
    ],
  });
  const edit_quantity = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderSubscription,
        operation: EnumOperation.edit_quantity,
      }),
    ],
  });
  const edit_customer = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderSubscription,
        operation: EnumOperation.edit_customer,
      }),
    ],
  });
  const cancel_subscription = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderSubscription,
        operation: EnumOperation.cancel_subscription,
      }),
    ],
  });
  return {
    view_subscription_buy_listing_page,
    view_subscription_buy_details_page,
    edit_quantity,
    edit_customer,
    cancel_subscription,
  };
};

const OrderList = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const timezoneInUTC = handleOnGetStoreTimezoneUTC();

  const {
    view_subscription_buy_listing_page,
    view_subscription_buy_details_page,
  } = permissions();
  // console.log('currencies', currencies);
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  /* 分页 */
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [noProducts, setNoProducts] = useState(false);
  const [sortBy, setSortBy] = useState<any>({});
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [tabsActive, setTabsActive] = useState(ETab.all);
  const [salesChannels, setSalesChannels] = React.useState([]);
  const [reportingCurrency, setReportingCurrency] = React.useState('');
  //console.log('tabsActive', tabsActive);
  //分页配置
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const { clearSearchState, queryProps, search } = useQueries(
    filterList(salesChannels, { getI18n }),
    [],
    customerConvertQuery,
  );

  const orderStatuses = tabDict[tabsActive];
  const conditions = {
    orderStatuses,
    ...search,
    ...(Object.keys(sortBy).length ? { sortBy } : {}),
    startDate,
    endDate,
  };

  /* 多选 */
  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    setMappedSelectedKeys,
    //mappedSelectedKeys,
    setSelectedRowKeys,
  } = useSelectRows(data);

  const buttonMenu = [
    //不知道
    //Bulk Edit
    // {
    //   key: 1,
    //   value: 'Invoices',
    //   function: () => {
    //     if (selectedRowKeys.length > 0) {
    //       printInvoice({ orderUuids: selectedRowKeys }).then((data) => {
    //         console.log(data, 'data=====>');
    //       });
    //     }
    //   },
    // },
  ];

  //清除table状态
  const clearTableState = () => {
    setSelectedRowKeys([]);
    setMappedSelectedKeys([]);
    setSelectedAll(false);
  };

  //tab改变事件
  const tabChange = (activeKey) => {
    clearTableState();
    clearSearchState();
    setCurrent(0);
    setSortBy({});
    // setStartDate('');
    // setEndDate('');
    setTabsActive(activeKey);
  };

  const getProduct = (cb) => {
    if (!loading) {
      setLoading(true);
    }
    const data = search;
    data.logisticsMethod = [];
    getSubscriptionList(current * pageSize, pageSize, conditions)
      .then((res) => {
        //console.log(res);
        const { results, totalCount } = res;
        setData(results || []);
        setTotal(totalCount);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (view_subscription_buy_listing_page) {
      getSubscriptionListInit(current * pageSize, pageSize, conditions).then(
        (res) => {
          //console.log(res);
          const { orders, reportingCurrency, salesChannels } = res;
          const { results, totalCount } = orders;
          setSalesChannels(salesChannels || []);
          setReportingCurrency(reportingCurrency);
          setData(results || []);
          setTotal(totalCount);
          if (totalCount <= 0) {
            setNoProducts(true);
          }
          setLoading(false);
        },
      );
    } else {
      setLoading(false);
    }
  }, []);

  useAfterDidMountEffect(() => {
    if (view_subscription_buy_listing_page) {
      getProduct(() => void 0);
    }
  }, [current]);

  useAfterDidMountEffect(() => {
    if (view_subscription_buy_listing_page) {
      if (!current) {
        getProduct(() => void 0);
      } else {
        setCurrent(0);
      }
    }
  }, [pageSize, search, sortBy, startDate, endDate]);

  const pageLayoutProps = {
    title: getI18n(
      'subscriptionBuy.subscriptionBuy.list_pageLayoutProps_title',
    ),
    //addText: 'Create New Order',
    //addFun,
    tabChange,
    activeKey: tabsActive,
    tabsConfig: tabsConfig({ getI18n }),
  };

  const handleTimePickerOnChange = (data) => {
    if (data) {
      setStartDate(data[0].format('YYYY-MM-DD'));
      setEndDate(data[1].format('YYYY-MM-DD'));
    } else {
      setStartDate('');
      setEndDate('');
    }
  };

  const handleLinkToAddOrder = () => {
    history.push('/order/new');
  };

  return (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData({ getI18n })}></Breadcrumb>
      {noProducts ? (
        <NoDataPage
          title={getI18n(
            'subscriptionBuy.subscriptionBuy.list_return_noProduct_Yes_title',
          )}
          introduce={getI18n(
            'subscriptionBuy.subscriptionBuy.list_return_noProduct_Yes_introduce',
          )}
          buttonTitle={getI18n(
            'subscriptionBuy.subscriptionBuy.list_return_noProduct_Yes_buttonTitle',
          )}
          onClick={handleLinkToAddOrder}
        />
      ) : (
        <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
          <GlobalTable
            id='OrderGiftCardList'
            showTimePicker
            timePickerValue={[
              startDate ? moment(startDate) : null,
              endDate ? moment(endDate) : null,
            ]}
            timePickerOnChange={handleTimePickerOnChange}
            queryProps={queryProps}
            dataSource={data || []}
            columns={columns(timezoneInUTC, reportingCurrency, '', { getI18n })}
            selectedAll={selectedAll}
            setSelectedAll={setSelectedAll}
            buttonMenu={buttonMenu}
            rowKey='uuid'
            pagination={paginationProps}
            current={current}
            setCurrent={setCurrent}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total={total}
            holdHeader
            bulkEditText={getI18n(
              'subscriptionBuy.subscriptionBuy.list_return_noProduct_No_bulkEditText',
            )}
            rowSelection={rowSelection}
            totalText={getI18n(
              'subscriptionBuy.subscriptionBuy.list_return_noProduct_No_totalText',
            )}
            selectedRowKeys={selectedRowKeys}
            hidePagination={total == 0}
            onRow={(record) => ({
              onClick: view_subscription_buy_details_page
                ? () =>
                    history.push(`/order/subscriptionBuy/edit/${record.uuid}`)
                : null,
            })}
            onChange={(_, s, sort) => {
              //console.log('sort', sort);
              const ascent = sort.order == 'ascend' ? true : false;
              const field = sort.columnKey;
              setSortBy({ field, ascent });
            }}
            loading={loading}
          />
        </ListPageLayout>
      )}
    </React.Fragment>
  );
};

export default memo(OrderList);
